import { render, staticRenderFns } from "./PayTypeSelect.vue?vue&type=template&id=f8260050&"
import script from "./PayTypeSelect.vue?vue&type=script&lang=js&"
export * from "./PayTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PayTypeSelect.vue"
export default component.exports